import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box
} from '@mui/material'
import ErrorMessage from '../../../component/shared/component/ErrorMessage'
import { useGetSalesRecipients } from '../../../api/sales-commission-incentive'
import RecipientRow from './RecipientRow'
import { LoadingSkeletonRows } from '../../shared/LoadingSkeletonRows'
import RecipientDialog from './RecipientDialog'
import RecipientImport from './RecipientImport'
import { useGetSalesIds } from '../../../api/sales'

const RecipientTable = ({
  search,
  onEdit,
  openDialog,
  setOpenDialog,
  editData,
  openImport,
  setOpenImport
}) => {
  const { data: allSalesIds = [], isLoading: isLoadingSalesIds } = useGetSalesIds()
  const { data: recepients = [], isLoading, refetch } = useGetSalesRecipients({ search })

  return (
    <Box>
      {recepients.length || isLoading ? (
        <TableContainer component={Paper}>
          <MuiTable>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Employee Code</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Sales IDs</TableCell>
                <TableCell align='right'>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <LoadingSkeletonRows rows={10} length={4} />
              ) : (
                recepients.map((row) => (
                  <RecipientRow
                    key={row._id}
                    data={row}
                    onEdit={() => onEdit(row)}
                    refetch={refetch}
                  />
                ))
              )}
            </TableBody>
          </MuiTable>
        </TableContainer>
      ) : (
        <ErrorMessage empty />
      )}
      <RecipientDialog
        open={openDialog}
        setOpen={setOpenDialog}
        data={editData}
        refetch={refetch}
        allSalesIds={allSalesIds}
        isLoadingSalesIds={isLoadingSalesIds}
      />
      <RecipientImport open={openImport} setOpen={setOpenImport} refetch={refetch} />
    </Box>
  )
}

export default RecipientTable
